module.exports = __webpack_public_path__ + "static/media/mountains.9f3353b5.svg";